export default "__VITE_ASSET__Cigvwt6$__"